import makeStyles from '@mui/styles/makeStyles';

export const useAdmitRootStyles = makeStyles((theme) => ({
  groupRoot: {
    marginBottom: 10,
    padding: 5,
    borderRadius: 5,
  },
  background: {
    backgroundColor: theme.palette.background.default,
  },
  dialogTitle: {
    padding: "10px",
  },
  titleWithCloseButton: {
    fontSize: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    paddingLeft: "24px",
  },
  dialogContent: {
    width: "100%",
  },
  stickyHeader: {
    position: "sticky",
    backgroundColor: theme.palette.background.default,
    top: 0,
  },
  body: {
    width: "90%",
    margin: "0 5% 5% 5%",
    // height: '70%'
  },
  paperRoot: {
    backgroundColor: theme.palette.background.paperDarker,
    background: theme.palette.background.paperDarker,
    backgroundImage: "",
  },
  content: {
    padding: 20,
    margin: 20,
  },
  bodyTitle: {
    // paddingLeft: 20
    fontSize: 18,
  },
  title: {
    textAlign: "center",
    width: "100%",
  },
  root: {
    backgroundColor: `${theme.palette.background.paper} !important`,
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  search: {
    borderRadius: theme.shape.borderRadius,
    //backgroundColor: theme.palette.background.paper,
    "&:hover": {
      // backgroundColor: theme.palette.background.,
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
    width: "60% !important",
    left: "20%",
    position: "fixed",
    marginTop: "-64px",
    fontSize: 20,
    textAlign: "center",
  },

  searchInput: {
    padding: "20px 0 20px 0",
    position: "relative",
    "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
      paddingLeft: " 40px !important",
    },
    width: "100%",
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    //height: '100%',
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.primary.mainColor,
    marginLeft: 0,
    marginTop: 8,
    zIndex: 2,
  },
  fullName: {
    display: "inline-block",
    marginLeft: 10,
    fontWeight: 300,
  },
  familyName: {
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: 5,
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    alignItems: "center",
  },
  vvip: {
    color: "#e46060",
    border: "1px solid #e46060",
    padding: "3px",
    fontSize: "10px",
    marginRight: "6px",
    borderRadius: "16px",
    verticalAlign: "middle",
    display: "inline-block",
    height: "20px",
  },
  searchButtons: {
    textAlign: "center",
  },
  tableHeader: {
    backgroundColor: theme.palette.mode === "light" ? "#e2e2e2" : "#363636",
    padding: "5px",
    marginBottom: "7px",
    color: "gray",
    fontSize: 12,
  },
  tableRecord: {
    padding: "8px",
    marginBottom: "7px",
    // backgroundColor: theme.palette.mode === "light" ? "#cacaca" : "#434343",
    background: theme.palette.mode === "light" ? "#cacaca" : "#434343",
    cursor: "pointer",
    "&:hover": {
      // backgroundColor: theme.palette.default.main,
      background: theme.palette.default.main,
    },
  },
  activeAttendance: {
    // backgroundColor: theme.palette.default.main,
    background: theme.palette.default.main,
    "&:hover": {
      // backgroundColor: theme.palette.default.light,
      background: theme.palette.default.light,
    },
  },
  bedasAttendance: {
    // backgroundColor: theme.palette.acuityColors.color4.background,
    background: theme.palette.acuityColors.color4.background,
    "&:hover": {
      // backgroundColor: theme.palette.acuityColors.color4.background,
      background: theme.palette.acuityColors.color4.background,
    },
  },
  isDeceased: {
    background:
      "repeating-linear-gradient(45deg, #8F8F8F 0, #8F8F8F 15px, #3C4042 15px, #3C4042 30px)",
    // backgroundColor: 'repeating-linear-gradient(45deg, #8F8F8F 0, #8F8F8F 15px, #3C4042 15px, #3C4042 30px)',
  },
  pagination: {
    width: "fit-content",
    margin: "auto",
  },
  fullNameHeader: {
    marginLeft: "10px",
  },
  sortedHeader: {
    cursor: "pointer",
  },
  buttonSelector: {
    borderRadius: 50,
    backgroundColor: theme.palette.grey["300"],
    color: "rgba(0, 0, 0, 0.87)",
    margin: "0 5px",
    fontSize: 10,
  },
  headerText: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  formControl: {
    width: "100%",
  },
  next: {
    width: "50%",
    margin: "auto",
  },
  error: {
    color: "#f44336",
  },
  patientHeaderItem: {
    fontSize: 14,
    verticalAlign: "top",
    lineHeight: "24px",
    display: "inline-block",
    margin: "0 5px",
    backgroundColor: theme.palette.background.paper,
    padding: "2px 7px",
    borderRadius: 5,
    "& .label": {
      marginRight: 5,
      fontSize: "90%",
    },
    "& .value": {
      fontWeight: "bold",
    },
  },
  userLog: {
    fontSize: 11,
    fontStyle: "italic",
    color: theme.palette.mode === "light" ? "#4B4B4B" : "#818181",
  },
  comment: {
    fontSize: 15,
    padding: 5,
    backgroundColor: theme.palette.background.default,
    borderRadius: 5,
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
    width: "100%",
    marginBottom: "15px",
    paddingTop: "12px",
    paddingLeft: "15px",
    paddingRight: "15px",
  },
  headerDemographics: {
    backgroundColor: theme.palette.mode === "light" ? "#e2e2e2" : "#404040",
    maxWidth: "max-content",
    flexBasis: "content",
    borderRadius: "10px",
    padding: "0.5rem 1rem",
    marginRight: "1rem",
    paddingRight: 0,
  },
  previousAttendancesContainer: {
    display: "flex",
    gap: 20,
    alignItems: "center",
    flexWrap: "nowrap",
  },
  divRow: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    alignItems: "center",
  },
  stepperContainer: {
    padding: "10px",
    borderRadius: 10,
    backgroundColor: theme.palette.background.paperDarker,
    backgroundImage: "unset",
  },
  stepButton: {
    cursor: "auto",

    "& .MuiStepIcon-root": {
      fill: "#FFF",
      "& svg": {
        fill: "#FFF",
      },
    },
  },
  headerStyles: {
    display: "flex",
    alignItems: "center",
    flexWrap: "nowrap",
    borderBottom: "none",
    backgroundColor: `${theme.palette.background.default} !important`,
  },
  filtersRow: {
    flexWrap: "wrap",
    marginTop: 5,
  },
  genderBox: {
    width: "fit-content",
    height: "38px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 10,

    "&.Female": {
      backgroundColor: "#F4BDD1"
    },
    "&.Male": {
      backgroundColor: "#92BFE2"
    },
    "& .MuiSvgIcon-root": {
      "& svg": {
        fill: "#000",
        color: "#000",
      },
    },
  },
  fromContext: {
    height: '90%',
  },
}));

export const useDemographicsStyles = makeStyles((theme) => ({
  body: {
    width: "90%",
    margin: "30px 5% 5% 5%",
  },
  paperRoot: {
    backgroundColor: theme.palette.background.paperDarker,
    background: theme.palette.background.paperDarker,
    backgroundImage: "unset",
  },
  content: {
    padding: 20,
    margin: 20,
  },
  bodyTitle: {
    fontSize: 18,
  },
  background: {
    backgroundColor: theme.palette.background.default,
  },
  backDrop: {
    backdropFilter: "blur(3px)",
    backgroundColor: "rgba(0,0,30,0.4)",
  },
  dialogTitle: {
    padding: "10px",
  },
  titleWithCloseButton: {
    fontSize: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    // padding: "10px 24px"
    paddingLeft: "24px",
  },
  dialogContent: {
    width: "100%",
  },
  title: {
    textAlign: "center",
    width: "100%",
  },
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  search: {
    borderRadius: theme.shape.borderRadius,
    "&:hover": {
      // backgroundColor: theme.palette.background.,
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
    width: "60% !important",
    left: "20%",
    position: "fixed",
    marginTop: "-64px",
    fontSize: 20,
    textAlign: "center",
  },

  searchInput: {
    padding: "20px 0 20px 0",

    "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
      paddingLeft: " 40px !important",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    //height: '100%',
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.primary.mainColor,
    marginLeft: 0,
    marginTop: 8,
  },
  fullName: {
    display: "inline-block",
    marginLeft: 10,
    fontWeight: 300,
  },
  familyName: {
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: 5,
  },
  vvip: {
    color: "#e46060",
    border: "1px solid #e46060",
    padding: "3px",
    fontSize: "10px",
    marginRight: "6px",
    borderRadius: "16px",
    verticalAlign: "middle",
    display: "inline-block",
    height: "20px",
  },
  patientsTable: {},
  searchButtons: {
    textAlign: "center",
  },
  tableHeader: {
    backgroundColor: theme.palette.mode === "light" ? "#e2e2e2" : "#363636",
    padding: "5px",
    marginBottom: "7px",
    color: "gray",
    fontSize: 12,
  },
  tableRecord: {
    padding: "8px",
    marginBottom: "7px",
    backgroundColor: theme.palette.mode === "light" ? "#cacaca" : "#434343",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.default.main,
    },
  },
  pagination: {
    width: "fit-content",
    margin: "auto",
  },
  fullNameHeader: {
    marginLeft: "10px",
  },
  sortedHeader: {
    cursor: "pointer",
  },
  buttonSelector: {
    borderRadius: 50,
    backgroundColor: theme.palette.grey["300"],
    color: "rgba(0, 0, 0, 0.87)",
    margin: "0 5px",
    fontSize: 10,
  },
  headerText: {
    float: "left",
    marginTop: 4,
  },
  formControl: {
    width: "100%",
  },
  next: {
    width: "50%",
    margin: "auto",
  },
  error: {
    color: "#f44336",
  },
  patientHeaderItem: {
    fontSize: 14,
    verticalAlign: "top",
    lineHeight: "24px",
    display: "inline-block",
    margin: "0 5px",
    backgroundColor: theme.palette.background.paper,
    padding: "2px 7px",
    borderRadius: 5,
    "& .label": {
      marginRight: 5,
      fontSize: "90%",
    },
    "& .value": {
      fontWeight: "bold",
    },
  },
  buttonsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-end",
    width: "100%",
    marginBottom: "15px",
    paddingLeft: "15px",
  },
  currentPatient: {
    fontSize: "large",
    fontWeight: "bold",
    "&.center": {
      textAlign: "center",
    },
  },
  unknownPatientDate: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "nowrap",
    maxWidth: "230px",
  },
  phoneNumberContainer: {
    background: theme.palette.background.default,
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexGrow: 1,
  },
  bannerContainer: {
    width: "100%",
    marginLeft: 15,
  },
  errorBorder: {
    border: "1px solid red",
    boxShadow: "0 0 5px red",
  },
  errorBackground: {
    backgroundColor: theme.palette.error.main,
  },
  buttonNFA: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    alignItems: "center",
    margin: "5px 0",
  },
}));

export const useAttendanceDetailsStyles = makeStyles((theme) => ({
  body: {
    width: "90%",
    margin: "30px 5% 5% 5%",
  },
  content: {
    padding: 20,
    margin: 20,
  },
  bodyTitle: {
    // paddingLeft: 20
    fontSize: 18,
  },
  title: {
    textAlign: "center",
    width: "100%",
  },
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  search: {
    borderRadius: theme.shape.borderRadius,
    marginRight: theme.spacing(2),
    marginLeft: 0,
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
    width: "60% !important",
    left: "20%",
    position: "fixed",
    marginTop: "-64px",
    fontSize: 20,
    textAlign: "center",
  },

  searchInput: {
    padding: "20px 0 20px 0",

    "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
      paddingLeft: " 40px !important",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.primary.mainColor,
    marginLeft: 0,
    marginTop: 8,
  },
  fullName: {
    display: "inline-block",
    marginLeft: 10,
    fontWeight: 300,
  },
  familyName: {
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: 5,
  },
  vvip: {
    color: "#e46060",
    border: "1px solid #e46060",
    padding: "3px",
    fontSize: "10px",
    marginRight: "6px",
    borderRadius: "16px",
    verticalAlign: "middle",
    display: "inline-block",
    height: "20px",
  },
  patientsTable: {},
  searchButtons: {
    textAlign: "center",
  },
  tableHeader: {
    backgroundColor: theme.palette.mode === "light" ? "#e2e2e2" : "#363636",
    padding: "5px",
    marginBottom: "7px",
    color: "gray",
    fontSize: 12,
  },
  tableRecord: {
    padding: "8px",
    marginBottom: "7px",
    backgroundColor: theme.palette.mode === "light" ? "#cacaca" : "#434343",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.default.main,
    },
  },
  pagination: {
    width: "fit-content",
    margin: "auto",
  },
  fullNameHeader: {
    marginLeft: "10px",
  },
  sortedHeader: {
    cursor: "pointer",
  },
  buttonSelector: {
    borderRadius: 50,
    backgroundColor: theme.palette.grey["300"],
    color: "rgba(0, 0, 0, 0.87)",
    margin: "0 5px",
    fontSize: 10,
  },
  headerText: {
    float: "left",
    marginTop: 4,
  },
  formControl: {
    width: "100%",
  },
  next: {
    width: "50%",
    margin: "auto",
  },
  error: {
    color: "#f44336",
  },
  patientHeaderItem: {
    fontSize: 14,
    verticalAlign: "top",
    lineHeight: "24px",
    display: "inline-block",
    margin: "0 5px",
    backgroundColor: theme.palette.background.paper,
    padding: "2px 7px",
    borderRadius: 5,
    "& .label": {
      marginRight: 5,
      fontSize: "90%",
    },
    "& .value": {
      fontWeight: "bold",
    },
  },
  groupRoot: {
    marginBottom: 10,
    // padding: 5,
    borderRadius: 5,
  },
  paper: {
    padding: 10,
    backgroundColor: theme.palette.background.default,
  },
  centerRow: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    alignItems: "center",
  },
  userLog: {
    fontSize: 11,
    fontStyle: "italic",
    color: theme.palette.mode === "light" ? "#4B4B4B" : "#818181",
  },
  comment: {
    fontSize: 15,
    padding: 5,
    backgroundColor: theme.palette.background.default,
    borderRadius: 5,
  },
  clinician: {
    marginBottom: 10,
  },
  row: {
    width: "100%",
    marginBottom: 10,
  },
  feedback: {
    display: "flex",
    justifyContent: "space-between",
    // paddingRight: 6,
  },
  alignToRight: {
    display: "flex",
    justifyContent: "end",
  },
}));

export const useAdmitBedBookingStyles = makeStyles((theme) => ({
  content: {
    padding: 20,
    margin: 20,
  },
  background: {
    backgroundColor: theme.palette.background.default,
  },
  dialogTitle: {
    textAlign: "center",
    padding: "10px",
  },
  dialogContent: {
    width: "100%",
  },
  groupRoot: {
    marginBottom: 10,
    padding: 5,
    borderRadius: 5,
  },
  paper: {
    padding: 10,
    backgroundColor: theme.palette.background.default,
  },
  centerRow: {
    display: "flex",
    flexWrap: "nowrap",
    flexDirection: "row",
    alignItems: "center",
  },
  userLog: {
    fontSize: 11,
    fontStyle: "italic",
    color: theme.palette.mode === "light" ? "#4B4B4B" : "#818181",
  },
  comment: {
    fontSize: 15,
    padding: 5,
    backgroundColor: theme.palette.background.default,
    borderRadius: 5,
  },
  clinician: {
    marginBottom: 10,
  },
  row: {
    width: "100%",
    marginBottom: 10,
  },
  divider: {
    margin: "10px 0",
  },
}));

export const useSummaryStyles = makeStyles((theme) => ({
  body: {
    width: "90%",
    margin: "30px 5% 5% 5%",
  },
  content: {
    padding: 20,
    margin: 20,
  },
  bodyTitle: {
    fontSize: 18,
  },
  title: {
    textAlign: "center",
    width: "100%",
  },
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  search: {
    // position: 'relative',
    borderRadius: theme.shape.borderRadius,
    //backgroundColor: theme.palette.background.paper,
    "&:hover": {
      // backgroundColor: theme.palette.background.,
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
    // marginTop: '20px',
    width: "60% !important",
    left: "20%",
    position: "fixed",
    marginTop: "-64px",
    fontSize: 20,
    textAlign: "center",
    // backgroundColor: 'rgb(54 54 54)' //theme.palette.background.default // '#252525'
    //   backgroundColor: theme.palette.mode === 'light' ? '#cecece' : '#363636'
  },

  searchInput: {
    padding: "20px 0 20px 0",

    "& .MuiOutlinedInput-root .MuiAutocomplete-input": {
      paddingLeft: " 40px !important",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    //height: '100%',
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.primary.mainColor,
    marginLeft: 0,
    marginTop: 8,
  },
  fullName: {
    display: "inline-block",
    marginLeft: 10,
    fontWeight: 300,
  },
  familyName: {
    fontWeight: "bold",
    textTransform: "uppercase",
    marginRight: 5,
  },
  vvip: {
    color: "#e46060",
    border: "1px solid #e46060",
    padding: "3px",
    fontSize: "10px",
    marginRight: "6px",
    borderRadius: "16px",
    verticalAlign: "middle",
    display: "inline-block",
    height: "20px",
  },
  patientsTable: {},
  searchButtons: {
    textAlign: "center",
  },
  tableHeader: {
    backgroundColor: theme.palette.mode === "light" ? "#e2e2e2" : "#363636",
    padding: "5px",
    marginBottom: "7px",
    color: "gray",
    fontSize: 12,
  },
  tableRecord: {
    padding: "8px",
    marginBottom: "7px",
    backgroundColor: theme.palette.mode === "light" ? "#cacaca" : "#434343",
    // backgroundColor: "rgb(67 67 67)",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: theme.palette.default.main,
    },
  },
  pagination: {
    width: "fit-content",
    margin: "auto",
  },
  fullNameHeader: {
    marginLeft: "10px",
  },
  sortedHeader: {
    cursor: "pointer",
  },
  buttonSelector: {
    borderRadius: 50,
    backgroundColor: theme.palette.grey["300"],
    color: "rgba(0, 0, 0, 0.87)",
    margin: "0 5px",
    fontSize: 10,
  },
  headerText: {
    float: "left",
    marginTop: 4,
  },
  formControl: {
    width: "100%",
  },
  next: {
    width: "50%",
    margin: "auto",
  },
  error: {
    color: "#f44336",
  },
  patientHeaderItem: {
    fontSize: 14,
    verticalAlign: "top",
    lineHeight: "24px",
    display: "inline-block",
    margin: "0 5px",
    backgroundColor: theme.palette.background.paper,
    padding: "2px 7px",
    borderRadius: 5,
    "& .label": {
      marginRight: 5,
      fontSize: "90%",
    },
    "& .value": {
      fontWeight: "bold",
    },
  },
}));